/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 *  - PUBLIC_STATUS_CREATED: New requisite in form of order was added to system.
 - PUBLIC_STATUS_PENDING: Order in process.
 - PUBLIC_STATUS_COMPLETED: Order completes successfully.
 - PUBLIC_STATUS_FAILED: Order processing failed.
 */
export enum PayinCommonTraderOrderV1PublicStatus {
    PUBLIC_STATUS_UNSPECIFIED = 'PUBLIC_STATUS_UNSPECIFIED',
    PUBLIC_STATUS_CREATED = 'PUBLIC_STATUS_CREATED',
    PUBLIC_STATUS_PENDING = 'PUBLIC_STATUS_PENDING',
    PUBLIC_STATUS_COMPLETED = 'PUBLIC_STATUS_COMPLETED',
    PUBLIC_STATUS_FAILED = 'PUBLIC_STATUS_FAILED',
}
